import theme from "theme";

import Box from "components/Box";
import Image from "components/Image";

import { IDeal } from "entities/Deal/sdk";

interface IPrintableProjectImage {
  deal: IDeal;
}

const PrintableProjectImage = ({ deal }: IPrintableProjectImage) => {
  return (
    <>
      {deal.thumbnail && (
        <Box>
          <Image
            src={deal.thumbnail}
            imgix
            imgixHeight={920}
            sx={{
              height: "460px",
              width: "100%",
              objectFit: "cover",
              marginBottom: theme.spacing(2),
            }}
            imageDataTestid="uploaded-deal-cover-image"
          />
        </Box>
      )}
    </>
  );
};

export default PrintableProjectImage;
